import React from 'react';
import { Chip } from '@mui/material';
import { nicheConfig } from '../../theme';

const NicheChip = ({ niche, size = 'small', showEmoji = true, ...props }) => {
  const config = nicheConfig[niche] || nicheConfig.other;

  return (
    <Chip
      label={`${showEmoji ? config.emoji + ' ' : ''}${config.label}`}
      size={size}
      sx={{
        bgcolor: `${config.color}15`,
        color: config.color,
        fontWeight: 500,
        fontSize: '0.75rem',
        height: 24,
        border: `1px solid ${config.color}30`,
        '& .MuiChip-label': { px: 1 },
      }}
      {...props}
    />
  );
};

export default NicheChip;
